import { render, staticRenderFns } from "./TotalBookingsToday.vue?vue&type=template&id=755f71ec&scoped=true"
import script from "./TotalBookingsToday.vue?vue&type=script&lang=js"
export * from "./TotalBookingsToday.vue?vue&type=script&lang=js"
import style0 from "./TotalBookingsToday.vue?vue&type=style&index=0&id=755f71ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755f71ec",
  null
  
)

export default component.exports